import { useEffect } from 'react';

type ScriptPropsType = {
	url: string;
	container: HTMLElement;
	onRendered?: () => void;
};

export function Script({
	url,
	container,
	onRendered = () => {},
}: ScriptPropsType) {
	useEffect(() => {
		if (!container?.appendChild) {
			return () => {};
		}

		const script = document.createElement('script');
		script.src = url;

		container.appendChild(script);

		onRendered();

		return () => {
			container.removeChild(script);
		};
	}, [url]);

	return null;
}
